import type { PaymentMethodType } from '@patrianna/shared-patrianna-types/store/PaymentsFlowModule'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { getVerificationsCardsSelector } from '@patrianna-payments/shared-store/verifications/store/selectors'
import { useCallback, useMemo } from 'react'

import { maskifyCreditCard } from 'components/CardTile/utils'
import content from 'prismic-translates/page-verifications.json'
import { useAppSelector } from 'store/hooks'

const t = getTranslationFromJson([content])

/*
  ATTENTION
  FORMATED PAYMENT METHODS - JUST MOCK VALUES FOR DESIGN REQUIREMENTS AND FUTURE FEATURES
*/

export default function useSelectPaymentMethodValues() {
  const verificationsCards = useAppSelector(getVerificationsCardsSelector)
  const filteredCardsVerifications = useMemo(
    () => verificationsCards?.filter((card) => !['unverified', 'unverifiable'].includes(card.status)),
    [verificationsCards],
  )

  const defaultCardNumberValue = useMemo(() => ({ name: t('default_card_number'), value: '' }), [])
  const defaultPaymentMethodValue = useMemo(() => ({ name: t('default_payment_method'), value: '' }), [])

  const paymentMethodValues = useMemo(() => {
    if (filteredCardsVerifications?.length > 0) {
      return [defaultPaymentMethodValue, { name: t('mock_card_option'), value: 'CardPaymentMethod' }]
    }

    return [defaultPaymentMethodValue]
  }, [filteredCardsVerifications?.length, defaultPaymentMethodValue])

  const getCardValuesByPaymentMethod = useCallback(
    (paymentMethod: PaymentMethodType) => {
      if (paymentMethod === 'CardPaymentMethod') {
        const values = filteredCardsVerifications.map((value) => ({
          name: maskifyCreditCard(value.lastFour),
          value: `${value.cardBin}`,
        }))

        return [defaultCardNumberValue, ...values]
      }

      return [defaultCardNumberValue]
    },
    [filteredCardsVerifications, defaultCardNumberValue],
  )

  const getCardById = useCallback(
    (id: string) => {
      if (!id) {
        return null
      }

      return filteredCardsVerifications?.filter((card) => card.cardBin === id)?.[0]
    },
    [filteredCardsVerifications],
  )

  return {
    paymentMethodValues,
    getCardValuesByPaymentMethod,
    getCardById,
  }
}
